import { createAsyncThunk } from "@reduxjs/toolkit";
import { instance } from "src/services/api-client";
import { NotificationService } from "src/helpers/notifications";
import { errorResponsesTrns } from "src/translate/responses";
import { IResponseWithPagination } from "src/@types/api";
import { IDeal } from "src/@types/deals";

export const DEALS_SLICE_NAME = "deals";
export const ITEMS_PER_PAGE = 10;

interface Params {
  sorting: string;
  page?: number;
}

export const getDealsAsync = createAsyncThunk(
  `${DEALS_SLICE_NAME}/fetchDeals`,
  async ({ sorting = "", page = 1 }: Params, { rejectWithValue }) => {
    try {
      const sortingQueryStr = sorting ? `&status=${sorting}` : "";

      const { data } = await instance.get<IResponseWithPagination<IDeal>>(
        `/deals/my-deal/?page=${page}${sortingQueryStr}&page_size=${ITEMS_PER_PAGE}`
      );

      return data;
    } catch ({ response }) {
      const errorText = response?.data?.error;

      NotificationService.error(errorText || errorResponsesTrns.gettingDeals);

      return rejectWithValue(errorText);
    }
  }
);
